module.exports = __webpack_public_path__ + "static/media/trieste-26.2efc1438.jpg";